import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const Comprobante = ({ vendedor, pedido, medioPago }) => {
  const debito = 4
  const transferencia = 5
  const withCBU = [debito, transferencia]

  return (
    <div
      className="row mt-4 borde-perfil ml-auto mr-auto"
      style={{
        backgroundColor: '#f0f0f0',
        border: '#aaaaaa',
        borderStyle: 'dashed'
      }}
    >
      <div className="col-12 text-center">
        <h3>Esta operación finalizó y tu pedido ha sido confirmado.</h3>
        Click aquí para ir al pedido{' '}
        <Link to={'/pedidos'}>Pedido # {pedido.idPedido}</Link>
        <h3>Vendedor: {vendedor.razonSocial}</h3>
        <p>Email: {vendedor.email}</p>
        {vendedor.telefono && vendedor.telefono.trim() !== '' ? (
          <p>Teléfono: {vendedor.telefono}</p>
        ) : (
          ''
        )}
        {vendedor.celular && vendedor.celular.trim() !== '' ? (
          <p>Celular: {vendedor.celular}</p>
        ) : (
          ''
        )}
        <p>
          Domicilio:{' '}
          {vendedor.altura && vendedor.altura.trim() !== ''
            ? `${vendedor.calle} ${vendedor.altura}`
            : vendedor.calle}
        </p>
        {withCBU.includes(medioPago?.value) && (
          <>
            <p>
              <b>CBU:</b> 191040734004070700010820
            </p>
            <p>
              <b>Alias:</b> pagueme.aqui.mp
            </p>
            <h3>
              Sr. comprador, una vez realizada la transferencia ingrese en esta compra y
              adjunte el comprobante para finalizar el pago y acordar la entrega.
            </h3>
          </>
        )}
      </div>
    </div>
  )
}

Comprobante.propTypes = {
  vendedor: PropTypes.shape({
    razonSocial: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    telefono: PropTypes.string,
    celular: PropTypes.string,
    calle: PropTypes.string.isRequired,
    altura: PropTypes.string
  }).isRequired,
  pedido: PropTypes.shape({
    idPedido: PropTypes.number.isRequired
  }).isRequired,
  medioPago: PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired
}

export default Comprobante
